import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import { 
	addError as addErrorReducer,
} from './reducer';

export const reserveSlice = createSlice({
  name: 'errors',
  initialState: initialState,
  reducers: {
    addError: addErrorReducer,
  },
});

export const { addError } = reserveSlice.actions;

export const errorsSelector = (state) => state.errors.errorList;

export default reserveSlice.reducer;